// Research Engine — wordmark. Concentric square "aperture / book spine" mark.
export function Logo({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  const fontSize = { sm: "15px", md: "17px", lg: "22px" }[size];
  const markSize = { sm: 16, md: 20, lg: 26 }[size];
  return (
    <div className="inline-flex items-center gap-2.5 select-none">
      <svg width={markSize} height={markSize} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <rect x="2" y="2" width="28" height="28" rx="3" stroke="currentColor" strokeWidth="1.6" />
        <rect x="8" y="8" width="16" height="16" rx="1.5" fill="currentColor" opacity="0.9" />
        <rect x="13" y="2.5" width="0.8" height="27" fill="var(--bg)" opacity="0.95" />
      </svg>
      <span className="font-serif font-medium tracking-tight" style={{ fontSize, lineHeight: 1 }}>
        Research <span className="italic font-normal text-ink-dim">Engine</span>
      </span>
    </div>
  );
}
